import React, { useEffect, useMemo, useState } from "react";
import "./Timer.css";
import useAppHooks from "../../hooks/useAppHooks";

const Timer = () => {
  const { dispatch, selector } = useAppHooks();

  // Get API data
  const examState = selector((state) => state?.examSlice?.questionsList);

  const paperDuration = examState?.paper_duration || 10800; // fallback: 3h
  const totalTime = examState?.total_time || 0;
  const timeStatus = examState?.time_status || {};

  // Timer state
  const [timeLeft, setTimeLeft] = useState(paperDuration - totalTime);
  const [toast, setToast] = useState(null); // toast state

  // Fetch on mount

  // Reset timeLeft when API updates
  useEffect(() => {
    setTimeLeft(paperDuration - totalTime);
  }, [paperDuration, totalTime]);

  // Countdown once
  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Trigger toast when toast_time matches
  useEffect(() => {
    const checkToast = (status) => {
      if (status?.toast_time && timeLeft === status.toast_time) {
        setToast({
          text: status.toast_text,
          bgColor: status.toast_bg_color,
          textColor: status.toast_text_color,
        });

        // auto hide after 5 sec
        setTimeout(() => setToast(null), 5000);
      }
    };

    checkToast(timeStatus.second);
    checkToast(timeStatus.third);
  }, [timeLeft, timeStatus]);

  // Format time as HH:MM:SS
  const formattedTime = useMemo(() => {
    const hrs = Math.floor(timeLeft / 3600);
    const mins = Math.floor((timeLeft % 3600) / 60);
    const secs = timeLeft % 60;
    return [hrs, mins, secs].map((t) => String(t).padStart(2, "0")).join(":");
  }, [timeLeft]);

  // Calculate style from percentage
  const timerStyle = useMemo(() => {
    const percentLeft = (timeLeft / paperDuration) * 100;

    if (percentLeft > 60) {
      return {
        backgroundColor: timeStatus.first?.bg_color,
        color: timeStatus.first?.text_color,
      };
    } else if (percentLeft > 20) {
      return {
        backgroundColor: timeStatus.second?.bg_color,
        color: timeStatus.second?.text_color,
      };
    }
    return {
      backgroundColor: timeStatus.third?.bg_color,
      color: timeStatus.third?.text_color,
    };
  }, [timeLeft, paperDuration, timeStatus]);

  return (
    <div className="timer-container">
      <div className="timer-box" style={timerStyle}>
        <p>{timeLeft > 0 ? formattedTime : "00:00:00"}</p>
      </div>

      {toast && (
        <div
          className="toast-box"
          style={{
            backgroundColor: toast.bgColor,
            color: toast.textColor,
            marginTop: "8px",
            padding: "6px 12px",
            borderRadius: "6px",
            fontWeight: 500,
          }}
        >
          {toast.text}
        </div>
      )}
    </div>
  );
};

export default Timer;
